import { Hashtracking } from "@otto-ec/global-hashtracking";

window.o_global = window.o_global || {};
window.global = window.global || {};

/*🤫*/
/*🤫*/
window.global.hashtracking = new Hashtracking();
window.o_global?.eventLoader.onLoad(100, () => {
  new Hashtracking().hashTrack();
});
